<!--
 * @Author: awu
 * @Date: 2020-11-16 23:04:10
 * @LastEditors: pengyong
 * @LastEditTime: 2020-12-09 20:19:07
 * @Description: 修改密码
-->
<template>
    <div class="userInfo">
        <HeadLine>{{ $t("userCenter").modifyPsw }}</HeadLine>
        <div class="item" style="margin-top: 27px;">
            <span class="title">{{ amendPassword.msg1 }}:</span>
            <div class="bc">
                <input v-model="password" autocomplete="new-password" type="password" :placeholder="amendPassword.msg1Placeholder" />
            </div>
        </div>
        <div class="item">
            <span class="title">{{ amendPassword.msg2 }}:</span>
            <div class="bc">
                <input v-model="newPassword" type="password" :placeholder="amendPassword.msg2Placeholder" />
            </div>
        </div>
        <div class="item">
            <span class="title">{{ amendPassword.msg3 }}:</span>
            <div class="bc">
                <input v-model="newPasswordAgain" type="password" :placeholder="amendPassword.msg3Placeholder" />
            </div>
        </div>
        <div class="btn">
            <div class="save">
                <CommonButton fontSize="14px" :disabled="disabled" @click="handleSubmit"> {{ amendPassword.bc }}</CommonButton>
            </div>
            <!-- <div class="exit" @click="handleLogout">{{ $t("userCenter").exit }}</div> -->
        </div>
    </div>
</template>

<script>
import api from "@/api";
import CommonButton from "@/components/CommonButton";
import HeadLine from "./components/HeadLine";
export default {
    data() {
        return {
            password: "",
            newPassword: "",
            newPasswordAgain: ""
        };
    },
    components: {
        HeadLine,
        CommonButton
    },
    mounted() {},
    methods: {},
    computed: {
        disabled() {
            return !(this.password && this.newPassword && this.newPasswordAgain);
        },
        amendPassword() {
            return this.$t("amendPassword");
        }
    },
    methods: {
        handleLogout() {
            window.logout();
        },
        handleSubmit() {
            if (this.newPassword !== this.newPasswordAgain) {
                this.$message.error(this.amendPassword.error);
                return;
            }
            api.changePassword({
                old_password: this.password,
                password: this.newPassword,
                password_confirmation: this.newPasswordAgain
            }).then((res) => {
                if (res.res === 1) {
                    this.$message.success(res.mes);
                    localStorage.removeItem("token_type");
                    localStorage.removeItem("access_token");
                    window.location.href = "/#/login";
                }
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.userInfo {
    padding-top: 40px;
    .item {
        width: 100%;
        height: 33px;
        display: flex;
        align-items: center;
        font-size: 14px;
        color: rgba(9, 70, 140, 1);
        margin-bottom: 20px;
        .title {
            width: 160px;
            text-align: right;
            margin-right: 13px;
            font-weight: 500;
        }
        .bc {
            height: 100%;
            width: 240px;
            background: rgba(9, 70, 140, 0.18);
            border-radius: 13px;
            color: rgba(9, 70, 140, 1);
            input {
                width: 100%;
                height: 100%;
                border: 0;
                background-color: transparent;
                box-sizing: border-box;
                padding: 2px 10px;
                font-size: 12px;
                color: rgba(9, 70, 140, 1);
                &::-webkit-input-placeholder {
                    color: rgba(9, 70, 140, 1);
                }
            }
        }
    }
    .btn {
        border-radius: 12px;
        margin-top: 60px;
        display: flex;
        align-items: center;
        .save {
            width: 97px;
            height: 39px;
            margin-left: 94px;
        }
        .exit {
            width: 97px;
            height: 40px;
            line-height: 40px;
            text-align: center;
            background: #f4f4f4;
            border-radius: 12px;
            margin-left: 23px;
            color: rgba(9, 70, 140, 1);
            font-weight: 600;
            font-size: 14px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/user/amendPassword.vue